import { POSAdapter } from './POSAdapter';
import { POSConfig } from './types';
import { MockPOSAdapter } from './adapters';

/**
 * Factory to create the appropriate POS adapter based on configuration
 */
export class POSAdapterFactory {
  /**
   * Create a POS adapter instance based on the provider in config
   */
  static createAdapter(config: POSConfig): POSAdapter {
    if (!config.enabled) {
      throw new Error('POS integration is not enabled for this restaurant');
    }

    switch (config.provider) {
      case 'mock':
        return new MockPOSAdapter(config);
      
      // Future POS integrations:
      // case 'inflo':
      //   return new InFloPOSAdapter(config);
      // case 'alegra':
      //   return new AlegraPOSAdapter(config);
      
      default:
        throw new Error(`Unsupported POS provider: ${config.provider}`);
    }
  }

  /**
   * Validate POS configuration
   */
  static validateConfig(config: POSConfig): boolean {
    if (!config.provider) {
      throw new Error('POS provider is required');
    }

    // Mock doesn't need credentials
    if (config.provider === 'mock') {
      return true;
    }

    // Other providers need credentials
    if (!config.credentials) {
      throw new Error('POS credentials are required for non-mock providers');
    }

    // Provider-specific validation
    switch (config.provider) {
      case 'inflo':
        if (!config.credentials.apiKey || !config.credentials.accountId) {
          throw new Error('InFlo requires API Key and Account ID');
        }
        break;
      
      case 'alegra':
        if (!config.credentials.apiKey || !config.credentials.apiSecret) {
          throw new Error('Alegra requires API Key and API Secret');
        }
        break;
      
      case 'toast':
        if (!config.credentials.apiKey || !config.credentials.apiSecret) {
          throw new Error('Toast requires API Key and API Secret');
        }
        break;
      
      case 'square':
        if (!config.credentials.apiKey || !config.credentials.apiSecret) {
          throw new Error('Square requires API Key and API Secret');
        }
        break;
      
      // Add more validation as needed
    }

    return true;
  }
}
